/** Shared geometry and typography for secondary-rail menus, including portalled menus. */
export const RAIL_MENU_ROW = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  w: 'full',
  minW: 0,
  h: '36px',
  minH: '36px',
  px: '12px',
  py: '0',
  gap: '10px',
  borderRadius: '8px',
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: '500',
  textDecoration: 'none',
  color: 'ui.text.secondary',
  _hover: { bg: 'ui.surface.rowHover', color: 'ui.text.primary', textDecoration: 'none' },
  _focusVisible: { outline: '2px solid', outlineColor: 'ui.border.accent', outlineOffset: '-2px' },
  css: { '& > svg': { width: '16px', height: '16px', flexShrink: 0 } },
} as const;

export const RAIL_MENU_ACTIVE = {
  bg: 'ui.surface.selected',
  color: 'ui.text.primary',
  fontWeight: '500',
} as const;

export const RAIL_MENU_LABEL = {
  fontSize: '11px',
  fontWeight: '600',
  lineHeight: '16px',
  color: 'ui.text.tertiary',
  letterSpacing: '0',
  textTransform: 'none',
} as const;
